import { ButtonGroup, HStack } from '@chakra-ui/react';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { PageControlButton } from './components/page-control-button';
import { UsePaginationLabelReturn } from './hooks';

export function PaginationArrow({
    hasNextPage,
    hasPreviousPage,
    handleNext,
    handlePrevious,
}: UsePaginationLabelReturn) {
    return (
        <HStack>
            <ButtonGroup spacing={0}>
                <PageControlButton
                    isDisabled={!hasPreviousPage}
                    icon={faChevronLeft}
                    onClick={handlePrevious}
                />
                <PageControlButton
                    isDisabled={!hasNextPage}
                    icon={faChevronRight}
                    onClick={handleNext}
                />
            </ButtonGroup>
        </HStack>
    );
}
